import React, { FunctionComponent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import withContext from '../../../ContextAPI/Context_HOC';
import NatConProxy from '../../Utilities/NatConProxy';

/**
 * Extracts year from National Convention taxonomy codename.
 * @param {string} input - taxonomy codename, should be like "national_convention_2025".
 */
function extractNumber(input: string): number | undefined {
  const match = input.match(/\d+/); // Find first occurrence of digits
  if (match === null) {
    const message = 'Natcon taxonomy codename is not in expected format';
    console.error(message);
  } else {
    return parseInt(match[0], 10);
  }
}

const NatConList: FunctionComponent<{
  context: { natConProxy: NatConProxy };
}> = ({ context: { natConProxy } }) => {
  const [natConYears, setNatConYears] = useState([] as number[]);
  const potentialYears: string[] = [];
  const currentYear = new Date().getFullYear();
  const startingYear = 2022;

  for (let i = startingYear; i <= currentYear; i++) {
    potentialYears.push(`national_convention_${i}`);
  }

  useEffect(() => {
    const natConProxyGetNatConsSubscription = natConProxy.getNatCons(potentialYears).subscribe((x) => {
      const availableYears: number[] = Array.from(new Set(x.map((a) => extractNumber(a.natcon.value[0].codename) || 0)))
        .sort()
        .reverse();
      setNatConYears(availableYears);
    });
    return () => natConProxyGetNatConsSubscription.unsubscribe();
  }, [natConProxy]);

  return (
    <div>
      {natConYears.map(function (val, i) {
        return (
          <div key={i}>
            <Link to={`news/natcon-${val}`}>{`National Convention ${val}`}</Link>
          </div>
        );
      })}
    </div>
  );
};
export default withContext(NatConList);
